<!-- // accordian section \\ -->
<section class="accordian-section needHelp contactSecFour home-accordian" id="faqs">
  <div class="comman-width">
    <app-accordian></app-accordian>
  </div>
</section>
<!-- \\ accordian section // -->

<!-- // banner section \\ -->
<section class="banner-section contactHeader contact-hero">
  <div class="contact-us-bg"></div>
  <div class="comman-width">
    <div class="over">
      <h2 class="contact-us-title">Contact Us</h2>
      <!-- <p class="is-hidden-mobile">Need any assistance? We are here to help.</p> -->
    </div>
  </div>
</section>
<section class="work-section hero-shape-left">
  <h2 class="contact-us-title">Contact Us</h2>
  <div class="columns is-vcentered contact-column-mobile">
    <div class="column p0">
      <div class="contact-form">
        <form method="post" name="contact_form" action="" id="contactForm" autocomplete="off">
          <div class="input-block">
            <input type="text" placeholder="Name" (focusout)="focusOutValidation('name')" (focus)="focusValidation('name')" id="name_" autocomplete="off">
            <div class="colorRed" *ngIf="emptyInput">Please enter your name </div>
          </div>
          <input type="email" name="email" id="email_" (focusout)="focusOutValidation('email')" (focus)="focusValidation('email')" [(ngModel)]="emailmodel"
            placeholder="Email" autocomplete="off" required>
          <div class="colorRed" *ngIf="emptyEmail">Please enter a valid email address</div>
          <div class="colorRed" *ngIf="invalidEmail">Please enter a valid email address</div>
          <textarea name="message" id="message" rows="10" (focusout)="focusOutValidation('message')" (focus)="focusValidation('message')" id="message">Write your message here</textarea>
          <div class="colorRed" *ngIf="emptyMessage">Please enter message</div>

          <!-- <img src="/assets/images/check.svg" height="20" width="20" alt=""> -->
          <re-captcha #captchaRef="reCaptcha" (resolved)="resolved($event)" size="invisible"
            siteKey="6LcY2gUaAAAAAB1rIXaSuXip3Bl0HOdolscjgsmU">
          </re-captcha>
          <label class="container">
            <input type="checkbox" [(ngModel)]="theCheckbox" data-md-icheck
              (change)="captchaRef.execute(); emptyCheckbox = false" />
            <span class="robo-label">I am not robot</span>
            <div class="colorRed" *ngIf="emptyCheckbox">
              Please check this box
            </div>
            <span class="checkmark"></span>

          </label>
          <p class="captchalink">
            This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply
          </p>

          <button (click)="validate()" type="submit" [class]="loader ? 'submit-button btn-loader' : 'submit-button'" id="contactSubmitBtn"><span>Submit</span></button>
          <div class="" id="contactsucess">
            Thank you.
          </div>
        </form>

      </div>
    </div>

    <div class="column">
      <div class="hero-image-contact-1" title="NuLifeSpan Rx support agent are always ready to help with your prescription discounts"></div>
    </div>
    <div class="column hero-image-contact-mobile is-hidden-desktop"></div>
  </div>
</section>

<!-- // Customer Support \\ -->
<!-- Work section -->
<section class="work-section contact-us">
  <div class="columns is-vcentered reverse-columns is-mobile">
    <div class="column col-contact-us">
      <!-- Best price  -->
      <div class="best-price is-hidden-mobile">
        <h2 class="customer-support">Customer Support</h2>
        <p class="subtitle">Need assistance? We are here to help. Any time of day, all 7 days of week, our support is
          here
          for you</p>
      </div>


      <!-- Discount card  -->
      <div class="columns">
        <div class="column">
          <!-- List item 2  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 cus one">
              <img src="../../assets/images/call-blue.svg" alt="">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="cu list-title">Call us</p>
                <p class="cu list-subtitle"><a href="tel://8557879328" style="color: inherit;">(855)-787-9328</a></p>
              </div>        
            </div>
          </div>
        </div>
      </div>

      <!-- Show pharmacist  -->
      <div class="columns">
        <div class="column">
          <!-- List item 3  -->
          <div class="columns list is-mobile">
            <div class="column list-image is-4 cus two">
              <img src="../../assets/images/mail-blue.svg" alt="">
            </div>
            <div class="column">
              <div class="list-item">
                <p class="cu list-title">Email us</p>
                <p class="cu list-subtitle"><a href="mailto:info@nulifespanrx.com"
                    style="color: #313131;">info@nulifespanrx.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-image-contact-2 is-hidden-desktop" title="Email or Call NuLifeSpan Rx for support on prescription discounts, even from the pharmacy!">
        <div class="green-circle"></div>
      </div>
    </div>
    <div class="column">
      <div class="best-price is-hidden-desktop is-hidden-tab">
        <h2 class="customer-support">Customer Support</h2>
        <p class="subtitle">Need assistance? We are here to help. Any time of day, all 7 days of week, our support is
          here
          for you</p>
      </div>

      <div class="hero-image-contact-2 is-hidden-mobile" title="Email or Call NuLifeSpan Rx for support on prescription discounts, even from the pharmacy!">
        <div class="green-circle"></div>
      </div>
    </div>
  </div>
</section>
<!--  END  -->
<!-- // Customer Support \\  -->